'use client';

import { HStack } from '@terra/ui-styled-system';
import type { ReactNode } from 'react';
import { OverviewWelcomeMessage } from './OverviewWelcomeMessage';

type WelcomeHeaderProps = {
  lastVisitAt?: Date | null;
  status?: ReactNode;
};

export function WelcomeHeader({ lastVisitAt, status }: WelcomeHeaderProps) {
  return (
    <HStack justifyContent="space-between" w="full" alignItems="center">
      <OverviewWelcomeMessage lastVisitAt={lastVisitAt} />
      {status}
    </HStack>
  );
}
